// extracted by mini-css-extract-plugin
module.exports = {"apartments":"da51a739f7--apartments--t6Zrr","apartments__item":"da51a739f7--apartments__item--g6fEm","apartments__line":"da51a739f7--apartments__line--EdjO9"};